module.exports = "<header class=\"main-header\">\n  <!-- Header Navbar: style can be found in header.less -->\n  <nav class=\"navbar navbar-static-top justify-content-between\">\n    <div class=\"logo\">\n      <img src=\"assets/img/logo.png\" height=\"35\">\n    </div>\n    <span class=\"user-info\"><i class='fa fa-user'></i> {{authUser.firstName+ ' '+authUser.lastName}}</span>\n  </nav>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/header/header.component.html
// module id = ../../../../../src/app/main/header/header.component.html
// module chunks = main